import NoWrapTableCell from 'Components/NoWrapTableCell'
import { styled } from '@mui/material/styles'

const ClickableTableCell = styled(NoWrapTableCell)(() => ({
  cursor: 'pointer',
  fontWeight: 'bold'
}))

export default ClickableTableCell
